import { defineMessages } from 'react-intl';

export default defineMessages({
  archivedOptionTooltip: {
    id: 'app.components.select.archivedOptionTooltip',
    defaultMessage:
      'This option has been archived and is no longer available for new selections.',
  },
  bullhornOptionTooltip: {
    id: 'app.components.select.bullhornOptionTooltip',
    defaultMessage:
      'This option has been received from Bullhorn but is not available in Candidate.ly for new selections.',
  },
});
